import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { TeamDetails, AddTeam, UpdateTeam, DeleteTeam } from '../models/operations_persona';
import { environment } from '../../../environments/environment.prod';
import { SnackbarComponent } from '../components/snackbar/snackbar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
// import { UpdateTeam } from '../models/operations_persona';

@Injectable({
  providedIn: 'root',
})
export class TeamService {
  baseUrl: string = environment.teamUrl;
  baseUrl1: string = environment.dashboardUrl;
  baseUrl3: string = environment.dashboardCandidateListUrl;
  validateUrl: string = environment.validationUrl;
  elasticUrl: string = environment.elasticUrl;

  constructor(
    private httpclient: HttpClient,
    private snackBar: MatSnackBar,
  ) {}

  openSnackBar(message: object, panelClass: string) {
    this.snackBar.openFromComponent(SnackbarComponent, {
      data: message,
      panelClass: panelClass,
      duration: 2000,
    });
  }

  getTeamDetails(role, companyHiringTypeId): Observable<TeamDetails[]> {
    return this.httpclient.get<TeamDetails[]>(
      this.baseUrl + 'TeamMembers/getTeam/' + role + '?companyHiringTypeId=' + companyHiringTypeId,
    );
  }

  getUnitsList(reqBody): Observable<any[]> {
    return this.httpclient.post<any>(this.validateUrl + 'dbAdmin/getUnitList', reqBody);
  }

  //for ex infy units
  getUnitsListExinfy(reqBody): Observable<any[]> {
    return this.httpclient.post<any>(this.validateUrl + 'dbAdmin/getUnitCountList', reqBody);
  }

  getUnitProfileCount(reqBody): Observable<any> {
    return this.httpclient.post<any>(this.validateUrl + 'dbAdmin/getCountForUnit', reqBody);
  }

  getSourceList(reqBody): Observable<any> {
    return this.httpclient.post<any>(this.validateUrl + 'dbAdmin/getSourceList', reqBody);
  }

  getPUSourceList(reqBody): Observable<any> {
    return this.httpclient.post<any>(this.validateUrl + 'dbAdmin/getSourcesForUnit', reqBody);
  }

  getSourceProfileCount(reqBody): Observable<any[]> {
    return this.httpclient.post<any>(this.validateUrl + 'dbAdmin/getCountForSource', reqBody);
  }

  addTeamMember(data): Observable<AddTeam> {
    const reqBody = {
      employeeNumber: data.employeeNumber,
      companyHiringTypeId: data.companyHiringTypeId,
      roleCode: data.roleCode,
    };
    return this.httpclient.post<AddTeam>(this.baseUrl + 'TeamMembers/addTeam', reqBody);
  }

  assignProfiles(reqBody): Observable<any> {
    return this.httpclient.post<any>(this.baseUrl3 + 'autoAllocateByUnit/allocateByUnit', reqBody);
  }

  updateLeave(data: UpdateTeam): Observable<UpdateTeam> {
    return this.httpclient.post<UpdateTeam>(this.baseUrl + 'TeamMembers/applyLeave', data);
  }

  deleteTeamMember(employeeNumber, eventId, roleCode, companyHiringTypeId): Observable<DeleteTeam> {
    const options = {
      schedulerEmpNo: employeeNumber,
      eventId: eventId,
      roleCode: roleCode,
      companyHiringTypeId: companyHiringTypeId,
    };
    return this.httpclient.post<DeleteTeam>(
      this.baseUrl1 + 'schedulerService/deleteEventSchedulerBySchedulerEmpNo',
      options,
    );
  }

  getSchedulerTeammember(role, eventId, companyHiringTypeId): Observable<TeamDetails[]> {
    let params = new HttpParams();
    params = params.append('masterRoleCode', role);
    params = params.append('eventId', eventId);
    params = params.append('companyHiringTypeId', companyHiringTypeId);
    return this.httpclient.get<TeamDetails[]>(this.baseUrl + 'TeamMembers/getTeamForScheduler', { params: params });
  }

  updateSchedularLeave(data: UpdateTeam): Observable<UpdateTeam> {
    return this.httpclient.post<UpdateTeam>(this.baseUrl + 'TeamMembers/applyLeave', data);
  }

  addSchedularTeamMember(eventId, data): Observable<AddTeam> {
    // let params = new HttpParams();
    // params = params.append('companyHiringTypeId', data.companyHiringTypeId);
    // params = params.append('roleId', data.roleId);
    // params = params.append('employeeNumber', data.employeeNumber);
    // params = params.append('eventId', eventId);
    const reqBody = {
      employeeNumber: data.employeeNumber,
      companyHiringTypeId: data.companyHiringTypeId,
      roleCode: 'SCAS',
      eventID: eventId,
    };

    return this.httpclient.post<AddTeam>(this.baseUrl + 'TeamMembers/addTeamForScheduler', reqBody);
  }

  autoAllocate(body) {
    console.log(body);
    let textOptions = { headers:new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8'), responseType: 'text' as 'json'};
    return this.httpclient.post(this.elasticUrl + 'elasticCandidate/allocateApplicationsToScheduler', body,textOptions);
  }
}
